// services/boletos/boleto.service.ts
import { API } from "../api";
import {
  CriarBoletoPayload,
  CriarBoletoResponse,
  CriarBoletoCotacaoResponse,
} from "./boleto.types";

/**
 * POST /boleto
 */
export const criarBoleto = async (
  payload: CriarBoletoPayload,
): Promise<CriarBoletoResponse> => {
  const { data } = await API.post<CriarBoletoResponse>("/boletos", payload);

  return data;
};

/**
 * POST /boletos/cotacao/:id — boleto de UMA cotação (frete + imposto estimado).
 * Feature beta: o back-end responde 403 se a conta não estiver na allowlist.
 */
export const criarBoletoCotacao = async (
  cotacaoId: number,
  dueDate: string,
): Promise<CriarBoletoCotacaoResponse> => {
  const { data } = await API.post<CriarBoletoCotacaoResponse>(
    `/boletos/cotacao/${cotacaoId}`,
    { dueDate },
  );

  return data;
};
